/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import template from './tier-list-page.component.html';
import * as _ from 'lodash';
import {AngularModalService} from '../../common/modal/angular-modal.service';

import {PERMISSIONS} from '../../../components/auth/auth-constants';
import {decorateTiersWithNetworkState} from './tier-commons';
import {TierPriorityModalComponent} from './tier-priority-modal.component';
import {NetworkResource} from '../../../components/api/resources/resource/network.resource';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';
import {TierResource} from '../../../components/api/resources/resource/tier';
import {deferMarkForCheck} from '../../common/util/defer-mark-for-check';

@Component({
  standalone: false,
  selector: 'adn-tier-list-page',
  template
})
export class TierListPageComponent implements OnInit {
  tiers: any[] = [];
  resolved = false;
  readOnly = false;
  private network: any;

  constructor(
    @Inject(TierResource) private tierResource: any,
    @Inject(NetworkResource) private Network: any,
    @Inject(LocalNetworkProfile) private LocalNetworkProfile: any,
    @Inject(LocalUserPermissions) LocalUserPermissions: any,
    private angularModalService: AngularModalService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.readOnly = !LocalUserPermissions.hasNetwork(PERMISSIONS.manageSystem.apiKey)
      && !LocalUserPermissions.hasDataNetworkPermission(PERMISSIONS.dataAdmin.apiKey)
      && !LocalUserPermissions.hasNetworkPermission('POLITICAL_ADMIN', null, 'POLITICAL');
  }

  ngOnInit(): void {
    this.loadTiers();
  }
  updatePriority(): void {
    const modalRef = this.angularModalService.show(TierPriorityModalComponent, {
      class: 'modal-lg',
      initialState: {inputNetwork: this.network}
    });
    (modalRef.content as TierPriorityModalComponent).onSaved.subscribe((updatedNetwork: any) => {
      this.network = updatedNetwork;
      this.loadTiers();
      this.LocalNetworkProfile.set('tiers', updatedNetwork.tiers);
    });
  }

  private loadTiers(): void {
    this.resolved = false;
    const tiersPromise = this.tierResource.query().$promise;
    const networkPromise = this.network || this.Network.get({id: this.LocalNetworkProfile.getNetworkId()}).$promise;

    Promise.all([tiersPromise, networkPromise]).then((results: any[]) => {
      deferMarkForCheck(this.cdr, () => {
        this.tiers = _.orderBy(decorateTiersWithNetworkState(results[0].results || [], results[1]), 'pos');
        this.network = results[1];
        this.resolved = true;
      });
    });
  }
}
